/**
 * MapLibre GL JS v6 worker files must be served as an unhashed sibling pair.
 * Next (Turbopack and webpack) hashes `new URL(..., import.meta.url)` and
 * does not emit `maplibre-gl-shared.mjs` next to the worker, so tiles never
 * load. `next.config.mjs` copies `dist/` → `public/maplibre/` at config load.
 *
 * Client-safe: no Node builtins. ArtifactMap imports this for `setWorkerUrl`.
 */
export const MAPLIBRE_PUBLIC_DIR = 'maplibre';
export const MAPLIBRE_WORKER_FILES = [
  'maplibre-gl-worker.mjs',
  'maplibre-gl-shared.mjs',
];
export const MAPLIBRE_WORKER_URL = `/${MAPLIBRE_PUBLIC_DIR}/maplibre-gl-worker.mjs`;
